export default __webpack_public_path__ + "img/770484fd384427d3a9972151c8dae8da.png";